export interface SkinClickEvent {
  icon: string;
  name: string;
  price: number | undefined;
  color: string;
  id: number | null;
  appId: number | null;
}
